import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import RHService from '../../../../services/rh';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [empresa, setEmpresa] = useState("");
    const [cargo, setCargo] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchTerceirizados()
            setNome("")
        } else {
            var response = await RHService.buscarTerceirizados(query)
            if (response.data.length >= 1) {
                props.setTerceirizados(response.data)
                props.setVazio(false)
                setNome("")
            } else {
                props.setVazio(true)
                setNome("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome) prepQuery = prepQuery + `&nome=${encodeURI(nome)}`;
        if (empresa !== "false" && empresa != "false" && empresa !== "") prepQuery = prepQuery + `&empresa=${encodeURI(empresa)}`;
        if (cargo !== "false" && cargo != "false" && cargo !== "") prepQuery = prepQuery + `&cargo=${encodeURI(cargo)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={2}>
                    <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Funcionário"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={3}>
                            <Form.Group className="mb-3" controlId="locais">
                                <FloatingLabel
                                    label="Empresa"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="empresa"
                                        name="empresa"
                                        onChange={e => setEmpresa(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        {props.empresas.map((terc) => (
                                                <option key={terc._id} value={terc.empresa}>
                                                    {terc.empresa}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={3}>
                            <Form.Group className="mb-3" controlId="locais">
                                <FloatingLabel
                                    label="Cargo"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="cargo"
                                        name="cargo"
                                        onChange={e => setCargo(e.target.value)}
                                    >
                                        <option>TODOS</option>
                                        {props.empresas.map((terc) => (
                                                <option key={terc._id} value={terc.cargo}>
                                                    {terc.cargo}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/folha'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.terceirizados} nome={"Terceirizados"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#689a500b-d5fa-4e49-b260-8b509085347a" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca